import {
  IconNameEnum,
  useModuleBEM,
  useUiStyles,
} from "@b2bportal/core-themes";
import {
  CoreUiComponents,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Icon, Popover, PopoverContent, PopoverTrigger } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FilterPopover.module.scss";

export interface FilterPopoverComponentProps extends PlatformComponentProps {
  label: string;
  isApplied?: boolean;
  disabled?: boolean;
  popoverClassName?: string;
  disablePortal?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const COMPONENT_KEY = CoreUiComponents.FilterPopover;
export const FilterPopover = ({
  className,
  label,
  children,
  disabled,
  popoverClassName,
  isApplied = false,
  disablePortal = false,
  onOpenChange,
}: FilterPopoverComponentProps) => {
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY, {
    hasFilter: isApplied,
  });

  return (
    <div className={clsx(block, className)}>
      <Popover onOpenChange={onOpenChange}>
        <PopoverTrigger className={cn("filter-button")} disabled={disabled}>
          {label}
          <Icon
            className={cn("dropdown-icon")}
            iconName={IconNameEnum.dropdownTriangle}
          />
        </PopoverTrigger>
        <PopoverContent
          className={popoverClassName}
          disablePortal={disablePortal}
        >
          {children}
        </PopoverContent>
      </Popover>
    </div>
  );
};
